import {v4 as uuidv4} from 'uuid';
import {TodayGiftListResultVo} from '../../common/shared/api/nicolas/vo/TodayGiftListResultVo.interface';
import {Maybe, TodayGiftList, User} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSortOption} from './SortOption';

export function createTodayGiftList(
  userInfo: Maybe<User>,
  {
    display_ad,
    num_receivable_ticket,
    promotion_list,
    list,
    cat_opt_list,
    selected_cat_opt,
    subcat_opt_list,
    selected_subcat_opt,
    promotion_title,
    helix_description,
    helix_list,
  }: TodayGiftListResultVo
): TodayGiftList {
  return {
    id: uuidv4(),
    categoryList: cat_opt_list.map(sortOption =>
      createSortOption({sortOptVo: sortOption})
    ),
    subCategoryList:
      subcat_opt_list?.map(sortOption =>
        createSortOption({sortOptVo: sortOption})
      ) || [],
    displayAd: display_ad ? createDisplayAd(display_ad) : undefined,
    list:
      list?.map(todayGiftItemSeriesDto =>
        createNormalListViewItem(userInfo, {todayGiftItemSeriesDto})
      ) || [],
    promotionTitle: promotion_title,
    // TODO: 적절한 아이템 타입으로 변경하기
    promotionList:
      promotion_list?.map(itemSeriesDto =>
        createNormalListViewItem(userInfo, {
          todayGiftItemSeriesDto: itemSeriesDto,
        })
      ) || [],
    helixDescription: helix_description,
    helixList:
      helix_list?.map(helixTodayGiftListDto => ({
        id: uuidv4(),
        helixGiftTitle: helixTodayGiftListDto.helix_gift_title,
        list: helixTodayGiftListDto.list.map(itemSeriesDto =>
          createNormalListViewItem(userInfo, {
            todayGiftItemSeriesDto: itemSeriesDto,
          })
        ),
      })) ?? [],
    receivableTicketCount: num_receivable_ticket,
    selectedCategory: createSortOption({sortOptVo: selected_cat_opt}),
    ...(selected_subcat_opt &&
      // 카테고리 "전체" 일 경우에 subcategoryList는 없지만 selectedSubCategory가 있을 수 있습니다.
      // 카테고리가 전체일 경우 장르 필터는 노출할 필요가 없기 때문에 조건을 추가합니다.
      // https://podotree.atlassian.net/wiki/spaces/PSD/pages/3421078003?focusedCommentId=3439692313
      subcat_opt_list?.length > 0 && {
        selectedSubCategory: createSortOption({
          sortOptVo: selected_subcat_opt,
        }),
      }),
  };
}
